/**
 * Payment endpoints — wired to backend payments app
 */

import type { ApiEndpoint } from '../endpointsConfig'

export const paymentEndpoints: ApiEndpoint[] = [
  // Payment detail (get status of a payment)
  {
    name: 'paymentDetail',
    path: 'restohub-api/payments/{id}/',
    actions: ['GET'],
    tags: ['Payment'],
  },
  // Public order-config for menu (no auth needed, used by widget)
  {
    name: 'menuOrderConfig',
    path: 'restohub-api/menu-builder/public/menus/{id}/order-config/',
    actions: ['GET'],
    tags: ['MenuConfig'],
  },
]
